import { useState } from "react";
import { useAuth } from "../auth/AuthContext";

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (!result.ok) setError(result.error);
    setLoading(false);
  };

  const handleGoogle = async () => {
    setError("");
    setGoogleLoading(true);
    const result = await loginWithGoogle();
    if (!result.ok) setError(result.error);
    setGoogleLoading(false);
  };

  const inputStyle = {
    width: "100%", padding: "12px 16px", borderRadius: 10, fontSize: 14,
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)",
    color: "#fff", outline: "none", boxSizing: "border-box", transition: "border-color 0.2s",
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#070626", fontFamily: "'Inter', sans-serif",
    }}>
      <div style={{
        position: "fixed", top: "20%", left: "50%", transform: "translateX(-50%)",
        width: 600, height: 600, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(113,95,242,0.15) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />

      <div style={{
        background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 20, padding: "48px 44px", width: "100%", maxWidth: 420,
        backdropFilter: "blur(12px)", position: "relative", zIndex: 1,
      }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 36 }}>
          <img src="/1.svg" alt="Revoya" style={{ height: 52, objectFit: "contain" }} />
        </div>

        <h2 style={{
          color: "#fff", margin: "0 0 6px", fontSize: 22, fontWeight: 700,
          fontFamily: "'Poppins', sans-serif", textAlign: "center",
        }}>
          Advisory Portal
        </h2>
        <p style={{ color: "rgba(255,255,255,0.45)", margin: "0 0 32px", fontSize: 14, textAlign: "center" }}>
          Sign in to continue
        </p>

        {/* Google Sign-In */}
        <button
          onClick={handleGoogle}
          disabled={googleLoading || loading}
          style={{
            width: "100%", padding: "12px", borderRadius: 10, fontSize: 14, fontWeight: 600,
            background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)",
            color: "#fff", cursor: googleLoading ? "not-allowed" : "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
            marginBottom: 20, transition: "background 0.2s", fontFamily: "'Inter', sans-serif",
          }}
          onMouseEnter={e => { if (!googleLoading) e.currentTarget.style.background = "rgba(255,255,255,0.13)"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; }}
        >
          {!googleLoading && (
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              <path fill="none" d="M0 0h48v48H0z"/>
            </svg>
          )}
          {googleLoading ? "Signing in…" : "Continue with Google"}
        </button>

        {/* Divider */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.1)" }} />
          <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}>or</span>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.1)" }} />
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", color: "rgba(255,255,255,0.6)", fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: 0.5, textTransform: "uppercase" }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@revoya.ai" required style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = "#715FF2"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", color: "rgba(255,255,255,0.6)", fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: 0.5, textTransform: "uppercase" }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" required style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = "#715FF2"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
            />
          </div>

          {error && (
            <div style={{
              background: "rgba(223,28,65,0.12)", border: "1px solid rgba(223,28,65,0.3)",
              borderRadius: 8, padding: "10px 14px", color: "#ff6b84", fontSize: 13,
              marginBottom: 16, textAlign: "center",
            }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading || googleLoading}
            style={{
              width: "100%", padding: "13px", borderRadius: 10, fontSize: 15, fontWeight: 600,
              background: loading ? "#5A4AD0" : "#715FF2", color: "#fff", border: "none",
              cursor: loading ? "not-allowed" : "pointer", transition: "background 0.2s",
              fontFamily: "'Inter', sans-serif", letterSpacing: 0.3,
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.background = "#5A4AD0"; }}
            onMouseLeave={(e) => { if (!loading) e.target.style.background = "#715FF2"; }}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p style={{ color: "rgba(255,255,255,0.2)", fontSize: 12, textAlign: "center", marginTop: 28, marginBottom: 0 }}>
          &copy; {new Date().getFullYear()} Revoya Inc.
        </p>
      </div>
    </div>
  );
}
